<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script lang="ts">
import { IonApp, IonRouterOutlet } from "@ionic/vue"
import { defineComponent } from "vue"

export default defineComponent({
  name: "App",

  components: {
    IonApp,
    IonRouterOutlet,
  },
})
</script>

<style lang="less">
@import "@/styles/variables.less";

.img-preview .close {
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: transparent !important;
  color: transparent !important;
}

.modal_controller_class {
  --height: 100%;
  --max-height: 100%;
  --max-width: 100%;
  --min-height: 100%;
  --min-width: 100%;
  --width: 100%;
}

.common_center_modal_class {
  --height: 35rem;
  --max-height: 35rem;
  --min-height: 28rem;
  --max-width: 26rem;
  --min-width: 26rem;
  --width: 26rem;
  --overflow: visible;
  --backdrop-opacity: 0.6 !important;

  .ion-page {
    overflow: visible;
  }

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
  }
}

/*屏幕下半边框 超出边框部分依旧隐藏*/
.half_modal_controller_class {
  --height: 50%;
  --max-height: 50%;
  --max-width: 100%;
  --min-height: 50%;
  --min-width: 100%;
  --width: 100%;
}

/*屏幕下半边框 超出边框部分依旧隐藏*/
.half_bottom_modal_controller_class {
  --height: 50%;
  --max-height: 50%;
  --max-width: 100%;
  --min-height: 50%;
  --min-width: 100%;
  --width: 100%;
  align-items: flex-end;
  --border-radius: 1rem 1rem 0 0;
}

/*屏幕下半边框 超出边框部分依旧显示*/
.half_modal_controller_overflow_visible_class {
  --height: 50%;
  --max-height: 50%;
  --max-width: 100%;
  --min-height: 50%;
  --min-width: 100%;
  --width: 100%;
  --overflow: visible;

  .ion-page {
    overflow: visible;
  }
}

.down_modal_class {
  --height: 100%;
  --max-height: 100%;
  --max-width: 100%;
  --min-height: 100%;
  --min-width: 100%;
  --width: 100%;
  &::part(content) {
    border-radius: 1rem 1rem 0 0;
  }
}

/*带背景的 modal 中心弹框*/
.center_modal_controller_class {
  --height: 50vw;
  --max-height: 50vw;
  --max-width: 50vw;
  --min-height: 50vw;
  --min-width: 50vw;
  --width: 50vw;
  --overflow: visible;

  .ion-page {
    overflow: visible;
  }

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 7vw;
    background-image: url("@{base-url}ai_smart_reading/end_exercise_bg.png");
    background-size: cover;
    background-repeat: no-repeat;
  }

  &::part(backdrop) {
    background-color: #00000080;
  }
}

/*带背景的 modal 中心弹框  教练端评价弹窗*/
.center_modal_controller_class2 {
  --height: 441px;
  --max-height: 441px;
  --max-width: 89.33vw;
  /* --min-height: 50VW; */
  --min-width: 89.33vw;
  --width: 89.33vw;
  --overflow: visible;

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
}

/*带背景的 modal 中心弹框  打印资料*/
.center_modal_controller_class3 {
  --height: 230px;
  --max-height: 230px;
  --max-width: 79.47vw;
  --min-height: 230px;
  --min-width: 79.47vw;
  --width: 79.47vw;
  --overflow: visible;
  --backdrop-opacity: 0.32 !important;

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
}

/*自适应高度的 modal 中心弹框  选择抗遗忘方式*/
.center_modal_controller_class_select_forget {
  --height: 260px;
  --max-height: 260px;
  --max-width: 79.47vw;
  --min-height: 260px;
  --min-width: 79.47vw;
  --width: 79.47vw;
  --overflow: visible;
  --backdrop-opacity: 0.32 !important;

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
}
.center_modal_controller_class_quicklyStartClass {
  --height: 220px;
  --max-height: 220px;
  --max-width: 79.47vw;
  --min-height: 230px;
  --min-width: 79.47vw;
  --width: 79.47vw;
  --overflow: visible;
  --backdrop-opacity: 0.32 !important;

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
}
/*带背景的 modal 中心弹框  打印资料*/
.center_modal_controller_class5 {
  --height: 60vw;
  --max-height: 60vw;
  --max-width: 79.47vw;
  --min-height: 60vw;
  --min-width: 79.47vw;
  --width: 79.47vw;
  --overflow: visible;
  --backdrop-opacity: 0.32 !important;

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
}

/*带背景的 modal 中心弹框  教练端核对信息*/
.center_modal_controller_class4 {
  --height: 400px;
  --max-height: 400px;
  --max-width: 79.47vw;
  --min-height: 340px;
  --min-width: 79.47vw;
  --width: 79.47vw;
  --overflow: visible;
  --background: transparent;

  .ion-page {
    overflow: visible;
  }

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
}

/*不带背景的 modal 中心弹框*/
.common_center_modal_controller_class {
  --height: 50vw;
  --max-height: 50vw;
  --max-width: 50vw;
  --min-height: 50vw;
  --min-width: 50vw;
  --width: 50vw;
  --overflow: visible;

  .ion-page {
    overflow: visible;
  }

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 7vw;
  }
}

/*不带背景的 70%宽 modal 中心弹框*/
.common_center_70_modal_controller_class {
  --height: 70vw;
  --max-height: 70vw;
  --max-width: 80vw;
  --min-height: 70vw;
  --min-width: 80vw;
  --width: 80vw;
  --overflow: visible;

  .ion-page {
    overflow: visible;
  }

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 7vw;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
  }
}

/*提示 见 openModal文件 openMsgToast*/
.common_toast_controller_class {
  --background: #00000080;
  --box-shadow: none;
  text-align: center;
  --start: auto;
  --end: auto;
  --width: 100vw;
  --height: 100vh;
  --max-width: 100vw;

  &::part(container) {
    position: relative;
    z-index: 11;
    display: flex;
    overflow: visible;
    align-self: center;
    justify-self: center;
    width: 100%;
    &::before {
      content: "";
      width: 185px;
      height: 110px;
      display: inline-block;
      background-image: url("./assets/toast_bg.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top center;
      position: absolute;
      left: 50%;
      bottom: 53%;
      transform: translate(-50%, -50%);
      z-index: 8000;
    }
  }

  &::part(message) {
    width: 250px;
    height: 165px;
    border-radius: 30px;
    padding: 40px;
    font-size: 16px;
    overflow: auto;
    box-sizing: border-box;
    line-height: 1.2;
    text-align: center;
    vertical-align: middle;
    flex-direction: column;
    background-color: #ffffff;
    color: #868f9e;
    box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.3);
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    letter-spacing: 3px;
    z-index: 8001;
    /* 新增：水平/垂直居中 + 超出可滚动 */
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-overflow-scrolling: touch;
    word-break: break-word;
    -webkit-overflow-scrolling: touch;

    /* 隐藏滚动条（仍可滚动） - Firefox 与旧版 IE/Edge */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */

    /* 隐藏滚动条（仍可滚动） - WebKit/Chromium */
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    &::-webkit-scrollbar-thumb {
      background: transparent;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::before {
      content: "温馨提示";
      display: block;
      width: 100%;
      vertical-align: middle;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 15px;
      color: #262626;
    }
  }
}

/*不带背景的 70%宽 modal 中心弹框*/
.rectangle_center_modal_controller_class {
  --height: 70vw;
  --max-height: 70vw;
  --max-width: 60vw;
  --min-height: 70vw;
  --min-width: 60vw;
  --width: 60vw;
  --overflow: visible;

  .ion-page {
    overflow: visible;
  }

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 7vw;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
  }
}

span {
  user-select: none;
}

.input input:-webkit-autofill {
  box-shadow: 0 0 0 1000px #ffffff inset !important;
  color: black !important;
  -webkit-text-fill-color: black !important;
  caret-color: black !important;
}

.common_center_modal_controller_class1 {
  --height: 320px;
  --max-height: 320px;
  --max-width: 350px;
  --min-height: 320px;
  --min-width: 350px;
  --width: 350px;
  --overflow: visible;

  .ion-page {
    overflow: visible;
  }

  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
  }
}

.common_center_modal_container_transparent {
  --width: fit-content;
  --min-width: 250px;
  --height: fit-content;
  --border-radius: 0px;
  --background: transparent;
  --backdrop-opacity: 0;
}

//中心弹框 透明背景 黑色幕布
.common_center_modal_container_transparent1 {
  .ion-page {
    overflow: visible;
    background: rgba(0, 0, 0, 0.5);
  }
  &::part(content) {
    width: 100%;
    height: 100%;
    background-color: transparent;
  }
}

.all_modal_transparent {
  --width: 85vw;
  --min-width: 250px;
  --height: 100vh;
  --border-radius: 0px;
  --background: transparent;
  --backdrop-opacity: 0.7 !important;
}

.switch_modal_transparent {
  --width: 75vw;
  --min-width: 250px;
  --height: 100vh;
  --border-radius: 0px;
  --background: transparent;
  --backdrop-opacity: 0.2 !important;
}

.fill_page_action_sheet_class {
  --min-width: 100vw;
  margin-inline-start: 0;
  margin-inline-end: 0;
}

.action_sheet_empty_class {
  text-align: center;
  --button-color: #97989c;
  .action-sheet-button-inner {
    font-size: 0.8rem;
  }
}

.underline hr {
  background: #606266;
}

.popover_class {
  --width: 100%;
  overflow: scroll;
  &::part(backdrop) {
    position: fixed;
  }
  &::part(content) {
    min-width: 10rem;
  }
}

/* 确保 Popover 不会超出屏幕 */
.grammar-popover {
  --offset-y: -50px;

  &::part(content) {
  }
}
</style>
